import * as z from 'zod';
export var createOrUpdateWebhookFormSchema = function () {
    return z.object({
        webhook_value: z.string().min(2, { message: 'webhook.validation.value.min' }).max(1000, { message: 'webhook.validation.value.max' }),
    });
};
